import { Factory } from '@wix/fe-essentials-viewer-platform/bi';
import type { PlatformBIUtils } from '../types';
import { Logger } from '@wix/web-bi-logger/dist/src/types';
import {
  clickContinueEWalletModalSf,
  checkoutRedirectToCheckoutFromExpressCheckout,
  cartExpressButtonWasPresentedSrc130Evid158,
} from '@wix/bi-logger-ecom-platform-data/v2';

export class ExpressCheckoutBIService {
  private readonly logger!: Logger;

  constructor(platform: PlatformBIUtils) {
    const loggerFactory = platform.biLoggerFactory?.();
    /* istanbul ignore if */
    if (!loggerFactory) {
      return;
    }

    this.logger = fixOldLoggerFactoryDueToWorkerYoshiV4(loggerFactory)
      .updateDefaults({
        bi_token: platform.bi?.biToken,
        appName: 'Express Checkout',
        _msid: platform.bi?.metaSiteId,
      })
      .logger();
  }

  public clickContinueEWalletModalSf(checkoutId: string) {
    void this.logger.report(
      clickContinueEWalletModalSf({
        checkoutId,
      }),
    );
  }

  public reportExpressCheckoutButtonsPresented({
    origin,
    numOfExpressButtonPresented,
  }: {
    origin?: string;
    numOfExpressButtonPresented?: number;
  }) {
    void this.logger.report(
      cartExpressButtonWasPresentedSrc130Evid158({
        origin,
        NumOfExpress_ButtonPresented: numOfExpressButtonPresented,
      }),
    );
  }

  public reportNavigateToFastFlowCheckout({
    checkoutId,
    cartId,
    purchaseFlowId,
    reason,
  }: {
    checkoutId: string;
    cartId?: string;
    purchaseFlowId?: string;
    reason: string;
  }) {
    void this.logger.report(
      checkoutRedirectToCheckoutFromExpressCheckout({
        cartId,
        checkoutId,
        purchaseFlowId,
        reason,
      }),
    );
  }
}

function fixOldLoggerFactoryDueToWorkerYoshiV4(factory: Factory): Factory {
  /* istanbul ignore next */
  if ((factory as any).factory) {
    return (factory as any).factory() as Factory;
  }
  return factory;
}
